export default class GHGeometry extends THREE.Geometry {
  constructor () {
    super();

    this.selectable = false;
    this.visible = true;
    this.component = null;
    this.index = -1;
    this.materialId = -1;
    this.paintId = null;
  }

  clone () {
    let newGHGeometry = new GHGeometry();
    newGHGeometry.copy(this);
    newGHGeometry.selectable = this.selectable;
    newGHGeometry.visible = this.visible;
    newGHGeometry.component = this.component;
    newGHGeometry.index = this.index;

    return newGHGeometry;
  }

  setSelectable (sel) {
    this.selectable = sel;
  }

  setVisible (vis) {
    this.visible = vis;
  }

  setComponent (comp) {
    this.component = comp;
  }

  setIndex (ind) {
    this.index = ind;
  }
}



// WEBPACK FOOTER //
// ./src/assets/javascripts/gh/geometry/GHGeometry.js